import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ICON from 'components/cmp_icon/cmp_icon'

import TAB_DETAILS from './tab_details/crd_details/crd_details';
import TAB_AGES from './tab_ages/tab_ages';
import TAB_CONTACTS from './tab_contacts/tab_contacts';
import TAB_LOCATIONS from './tab_locations/tab_locations';
import TAB_ACTIVITIES from "./tab_activities/tab_activities";
import TAB_PAGES from './tab_pages/tab_pages';
import TAB_NOTES from 'containers/providers/provider_details/tab_notes/crd_notes_list/crd_notes_list';
import TAB_HISTORY from './tab_history/tab_history';

import './provider_details.css';



export default function PROVIDER_DETAILS() {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    const [ var_tab, set_tab ] = useState('DETAILS');
    const [ var_provider_name, set_provider_name ] = useState('');



    //  event listeners ------------------------------------------------------------------------------------------------



    //  async functions ------------------------------------------------------------------------------------------------



    //  API calls ------------------------------------------------------------------------------------------------------



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_tab(tab){
        set_tab(tab)
    }


    // RENDER CONTAINER ================================================================================================

    return (
        <div id='page--providers_details' className='page'>

            <div className='page__header'>
                <div className='text--xl medium'>{var_provider_name}</div>
            </div>

            <div className='tab'>
                <div className={'tab__item' + (var_tab === 'DETAILS' ? ' active' : '')} onClick={()=>onClick_tab('DETAILS')}>
                    <ICON name='store' className='tab__item__icon' alt='store icon'/>
                    <div className='text--base medium'>Details</div>
                </div>
                <div className={'tab__item' + (var_tab === 'LOCATIONS' ? ' active' : '')} onClick={()=>onClick_tab('LOCATIONS')}>
                    <ICON name='location' className='tab__item__icon' alt='store icon'/>
                    <div className='text--base medium'>Locations</div>
                </div>
                <div className={'tab__item' + (var_tab === 'ACTIVITIES' ? ' active' : '')} onClick={()=>onClick_tab('ACTIVITIES')}>
                    <ICON name='tag' className='tab__item__icon' alt='store icon'/>
                    <div className='text--base medium'>Activities</div>
                </div>
                <div className={'tab__item' + (var_tab === 'AGES' ? ' active' : '')} onClick={()=>onClick_tab('AGES')}>
                    <ICON name='birthday' className='tab__item__icon' alt='store icon'/>
                    <div className='text--base medium'>Ages</div>
                </div>
                <div className={'tab__item' + (var_tab === 'PAGES' ? ' active' : '')} onClick={()=>onClick_tab('PAGES')}>
                    <ICON name='pages' className='tab__item__icon' alt='store icon'/>
                    <div className='text--base medium'>Pages</div>
                </div>
                <div className={'tab__item' + (var_tab === 'NOTES' ? ' active' : '')} onClick={()=>onClick_tab('NOTES')}>
                    <ICON name='notes' className='tab__item__icon' alt='store icon'/>
                    <div className='text--base medium'>Notes</div>
                </div>
                <div className={'tab__item' + (var_tab === 'HISTORY' ? ' active' : '')} onClick={()=>onClick_tab('HISTORY')}>
                    <ICON name='history' className='tab__item__icon' alt='store icon'/>
                    <div className='text--base medium'>History</div>
                </div>
            </div>


            <div className='tab__pages__wrapper'>

                {var_tab === 'DETAILS' &&
                    <TAB_DETAILS
                        provider_id={provider_id}
                        current_tab={var_tab}
                        set_provider_name={set_provider_name}
                    />
                }

                {var_tab === 'CONTACTS' &&
                    <TAB_CONTACTS
                        current_tab={var_tab}
                    />
                }

                {var_tab === 'LOCATIONS' &&
                    <TAB_LOCATIONS
                        provider_id={provider_id}
                        current_tab={var_tab}
                    />
                }

                {var_tab === 'AGES' &&
                    <TAB_AGES
                        provider_id={provider_id}
                        current_tab={var_tab}
                    />
                }

                {var_tab === 'ACTIVITIES' &&
                    <TAB_ACTIVITIES
                        provider_id={provider_id}
                        current_tab={var_tab}
                        provider_name={var_provider_name}
                    />
                }

                {var_tab === 'PAGES' &&
                    <TAB_PAGES
                        provider_id={provider_id}
                        current_tab={var_tab}
                    />
                }

                {var_tab === 'NOTES' &&
                    <TAB_NOTES
                        provider_id={provider_id}
                        current_tab={var_tab}
                        provider_name={var_provider_name}
                    />
                }

                {var_tab === 'HISTORY' &&
                    <TAB_HISTORY
                        provider_id={provider_id}
                        current_tab={var_tab}
                    />
                }

            </div>

        </div>
    );

}